import {
  closeConfirmationModal,
  setConfirmationModalFormErrorMessage,
} from '../../actions/confirmationModal'
import { cancelSubscription } from '../../../api/paymentApi'
import { setUserDetails } from '../../actions/authActions'

export default () => (dispatch, getState) => {
  let {
    confirmationModal: { form, formErrors },
    userDetails,
  } = getState()
  const { ref } = userDetails.subscriptionDetails
  const { reason } = form

  let invalid = false

  if (!reason) {
    formErrors = {
      ...formErrors,
      reasonError: 'Grund erforderlich',
    }
    invalid = true
  }

  if (invalid) {
    dispatch(setConfirmationModalFormErrorMessage(formErrors))
    return
  }

  cancelSubscription(ref, form)
    .then(() => {
      dispatch(
        setUserDetails({
          ...userDetails,
          subscriptionDetails: {
            ...userDetails.subscriptionDetails,
            status: 'CANCELLED',
          },
        }),
      )
      dispatch(closeConfirmationModal())
    })
    .catch((err) => {
      console.log('err', err)
      // dispatch(setConfirmationModalErrorMessage('wrongSomething'))
    })
}
